<template>
    <div class="need-progress-wrapper">
        <div class="need-progress-container">
            <div class="need-progress-bar" :style="{width: progressWidth, 'background-color': progressBackgroundColor}"></div>
            <div class="need-progress-text">
                {{ this.donationsTotal | currency(0) }}<span v-show="goal"> out of {{ this.goal | currency(0) }}</span> donated
            </div>
        </div>
    </div>
</template>

<script>
    import { currency } from '../helpers/filters';

    export default {
        props: {
            donationsTotal: {
                type: Number,
                required: true,
            },
            goal: {
                type: Number,
                required: true
            }
        },
        filters: {
            currency
        },
        computed: {
            progressWidth() {
                if( ! this.donationsTotal || ! this.goal) {
                    return '0';
                }
                let complete = this.donationsTotal / this.goal;
                if(complete <= 0) {
                    return '0';
                }
                if(complete >= 1) {
                    return '100%';
                }
                return (Math.round(complete * 10000) / 100) + '%';
            },
            progressBackgroundColor() {
                let hue = 175;
                if( ! this.goal) {
                    return `hsl(${hue}, 66%, 61%)`;
                }
                let complete = this.donationsTotal / this.goal;
                if(complete > 1) {
                    complete = 1;
                }
                hue = Math.round(hue - (complete * 60));
                return `hsl(${hue}, 66%, 61%)`;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/variables";
    @import "../../sass/mixins";

    .need-progress-wrapper {
        width: 100%;
    }

    .need-progress-container {
        padding: 10px;
        height: 20px;
        border: 1px solid #DEDEDE;
        background-color: #FEFEFE;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        @include media($md) {
            height: 40px;
        }
    }

    .need-progress-bar {
        background-color: hsl(175, 66%, 61%);
        width: 0;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        transition: width 1000ms ease-out, background-color 1000ms ease-out;
    }

    .need-progress-text {
        font-weight: 600;
        font-size: 14px;
        color: #000;
        z-index: 1;
        @include media($md) {
            font-size: 20px;
        }
    }
</style>
